import UserModel from './UserModel.js';

class AuthMiddleware{

    login(userData,rememberMe = false){
        if(this.user){
            delete this.user;
            this.user = null;
        }
        this.user = new UserModel();
        this.user.set(userData);
        this.actualStorage = rememberMe ? localStorage : sessionStorage;
        this.setCache();
    }

    logout(){
        if(this.user){
            delete this.user;
            this.user = null;
        }
        this.user = new UserModel();
        window.axios.defaults.headers.common['Authorization'] = null;
        localStorage.clear();
        sessionStorage.clear();
        Notification.clear();
    }

    setCache(){
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${this.user.login_token}`;
        this.actualStorage.login_token = this.user.login_token;
    }

    checkIsUserLogged(){
        return new Promise((resolve, reject)=>{
            this.actualStorage = sessionStorage.login_token ? sessionStorage : localStorage;
            if(this.actualStorage.login_token){
                axios.post('/auth/checkAuth', {
                    loginToken: this.actualStorage.login_token ? this.actualStorage.login_token : ''
                })
                    .then((response) => {
                        if(response.data && response.data){
                            this.login(response.data);
                            resolve(response.data);
                        }else{
                            resolve(null);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }else{
                resolve(null);
            }
        });
    }

}

export default AuthMiddleware;